/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface WidgetSlideArrowProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const WidgetSlideArrow: React.SFC<WidgetSlideArrowProps> = ({size, ...props}) => (
  <svg viewBox="0 0 40 40" fill="currentColor" width={ size || "40" } height={ size || "40" } {...props}>
    <path fill="currentColor" opacity=".603" d="M17.54 19.792l7.527 7.347H21.9l-7.646-7.347 7.646-7.348h3.166z" fillRule="nonzero" />
  </svg>
);
WidgetSlideArrow.displayName = 'WidgetSlideArrow';
export default WidgetSlideArrow;
/* tslint:enable */
/* eslint-enable */
